"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const api_1 = require("@/api");
const functions_1 = require("@/common/functions");
const errors_1 = require("@/common/errors");
const string_utils_1 = require("@/common/string_utils");
const _1 = require(".");
function default_1({ isInputMode, roomId, recordFileChoice, recordField, expenseRecordForm, }) {
    const [imageUrl, setImageUrl] = (0, react_1.useState)(false);
    const closeImageViewer = () => setImageUrl(false);
    const imageFileRegExp = new RegExp(/(jpeg|jpg|png|webp)/);
    const downloadRecordFile = () => __awaiter(this, void 0, void 0, function* () {
        (0, functions_1.tempDisableClick)(1000);
        yield (0, api_1.getData)(`/api/v1/room/${roomId}/settlement-manage/expense/download?field_type=${recordFileChoice}`)
            .then(res => {
            const { presigned_url, filename } = res.data.result;
            const fileExtension = (filename === null || filename === void 0 ? void 0 : filename.split('.').pop()) || '';
            if (imageFileRegExp.test(fileExtension)) {
                setImageUrl(presigned_url);
            }
            else {
                const tempLink = document.createElement('a');
                tempLink.href = presigned_url;
                tempLink.download = filename;
                document.body.appendChild(tempLink);
                tempLink.click();
                document.body.removeChild(tempLink);
            }
        })
            .catch(err => {
            const { status } = err.response;
            if (status === 403)
                (0, errors_1.handle403Error)(err);
            else
                alert((0, errors_1.commonErrorMsg)(status) + '(failed to download file)');
        });
    });
    const recordFileName = expenseRecordForm.watch(`${recordField}_filename`);
    const truncatedFileName = recordFileName && (0, string_utils_1.truncateFileName)(20, recordFileName);
    const { setValue } = expenseRecordForm;
    if (isInputMode)
        return recordFileName ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ translate: "no", className: "body1 blue-50" }, { children: truncatedFileName })), (0, jsx_runtime_1.jsx)(_1.RecordFileDelete, { roomId: roomId, recordFileChoice: recordFileChoice, recordField: recordField, expenseRecordFormSetValue: setValue })] })) : ((0, jsx_runtime_1.jsx)(_1.RecordFileUploader, { roomId: roomId, recordFileChoice: recordFileChoice, recordField: recordField, expenseRecordFormSetValue: setValue }));
    return recordFileName ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ translate: "no", className: "body1 blue-50", css: { textDecoration: 'underline', cursor: 'pointer' }, onClick: downloadRecordFile }, { children: truncatedFileName })), (0, jsx_runtime_1.jsx)(_1.RecordFileImageDialog, { imageUrl: imageUrl, closeImageViewer: closeImageViewer })] })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}));
}
exports.default = default_1;
